import type { ReactNode } from 'react';

/**
 * The frame every credential page sits in (docs/DECISIONS.md ZD-118).
 *
 * Smaller and plainer than the workspace by nature: one card, one task,
 * ink on paper. This is the first thing a person ever sees of the product,
 * and it is where they decide whether it was built by people who are careful
 * — so nothing decorative, nothing animated, and every sentence on it is
 * either what the API said or what to do next.
 */
export function CredentialShell({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}): React.JSX.Element {
  return (
    <main className="cred">
      <div className="cred__card">
        <p className="cred__wordmark">Zevik</p>
        <h1>{title}</h1>
        {children}
      </div>
    </main>
  );
}

/** The API's refusal, in its own words. */
export function Refused({ message }: { message: string }): React.JSX.Element {
  return (
    <p className="notice notice--bad" role="alert">
      {message}
    </p>
  );
}
